<template>
    <div class="contentPointsMenu">
        <div class="text-xs-center" v-model="seePoints">
            <v-badge left>
                <!--<v-icon-->
                <!--large-->
                <!--color="white"-->
                <!--&gt;-->
                <!--favorite_border-->
                <!--</v-icon>-->
                <h3 class="puntsTitle">{{$t('pointsText')}}</h3>
                <div class="points animated">{{contadorPuntsCorrect - contadorPuntsFailed}}</div>
            </v-badge>
        </div>
    </div>

</template>

<script>
    import {db} from '../firebaseConfig'
    import 'vuejs-noty/dist/vuejs-noty.css'
    import firebase from 'firebase'

    let usersRef = db.ref('Users');


    export default {
        name: "PointsMenu",
        data() {
            return {
                contadorPuntsCorrect: 0,
                contadorPuntsFailed: 0,
                contadorPreguntesCorrect: 0,
                contadorPreguntesFailed: 0

            }
        },
        created () {
            //contador de punts a cero
            firebase.auth().onAuthStateChanged(function (user) {
                let updates = {};
                updates['Users/' + user.uid + '/' + 'pointsCorrectGame'] = 0;
                updates['Users/' + user.uid + '/' + 'pointsFailedGame'] = 0;
                updates['Users/' + user.uid + '/' + 'numberCorrectAnswersGame'] = 0;
                updates['Users/' + user.uid + '/' + 'numberFailedAnswersGame'] = 0;
                return firebase.database().ref().update(updates);
            });
            this.contadorPreguntesCorrect = 0;
            this.contadorPreguntesFailed = 0;
            this.contadorPuntsCorrect = 0;
            this.contadorPuntsFailed = 0;
        },
        methods: {

        },
        computed: {
            seePoints() {
                let this2 = this;
                firebase.auth().onAuthStateChanged(function (user) {
                    usersRef.child(user.uid).child('numberCorrectAnswerGame').on('value', snap => this2.contadorPreguntesCorrect = snap.val());
                    usersRef.child(user.uid).child('numberFailedAnswerGame').on('value', snap => this2.contadorPreguntesFailed = snap.val());

                    usersRef.child(user.uid).child('pointsCorrectGame').on('value', snap => this2.contadorPuntsCorrect = snap.val());
                    usersRef.child(user.uid).child('pointsFailedGame').on('value', snap => this2.contadorPuntsFailed = snap.val());

                });

            }
        }
    }

</script>

<style scoped>

    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');

    .contentPointsMenu {
        height: 33%;
        width: 33%;
    }

    .points {
        border-top: 0;
        position: relative;
        color: whitesmoke;
        font-family: 'Josefin Sans', sans-serif;
        font-weight: bold;
        font-size: 70px;
    }


    .puntsTitle {
        color: whitesmoke;
        font-family: 'Josefin Sans', sans-serif;
        font-weight: bold;
        font-size: 12px;
    }
</style>
